<template>
  <div class="page-header">Календарь мероприятий</div>
  <div class="content">
    <div class="filters">
      <div class="filter">
        <div class="content-header">Направления:</div>
        <div class="content-filter">
          <dropdownListWithHeader
            v-if="medTypes.length > 0"
            placeholder="Выберите направление"
            :search="false"
            :list="medTypes"
            @selectHandler="changeProcessType"
          />
        </div>
      </div>
      <div class="filter">
        <div class="content-header">Год:</div>
        <div class="year">
          <div class="previous-arrow" @click="currentYear = currentYear - 1" />
          <div class="year-text">{{ currentYear }}</div>
          <div class="next-arrow" @click="currentYear = currentYear + 1" />
        </div>
      </div>
    </div>
    <div :key="currentYear" class="horizontal-calendar">
      <div class="calendar-header">
        <div class="number-column column">№</div>
        <div class="process-column column">Процесс</div>
        <div class="quarter-column column" :style="{ width: quarterWidth(1) + 'px' }">1-й квартал</div>
        <div class="quarter-column column" :style="{ width: quarterWidth(2) + 'px' }">2-й квартал</div>
        <div class="quarter-column column" :style="{ width: quarterWidth(3) + 'px' }">3-й квартал</div>
        <div class="quarter-column column" :style="{ width: quarterWidth(4) + 'px' }">4-й квартал</div>
      </div>
      <div class="calendar-subheader">
        <div class="number-column column" />
        <div class="process-column column" />
        <template v-for="(quarter, key) in 4" :key="key">
          <div class="quarter-column column">
            <template v-for="(month, key) in quarter * 3" :key="key">
              <div v-if="key >= (quarter - 1) * 3" class="quarter-table" :class="{ gray: key % 2 !== 0 }">
                <div class="quarter-month">{{ months[month - 1] }}</div>
                <div class="quarter-days">
                  <div v-for="(day, key) in getDays(month)" :key="key" class="month-day">{{ day }}</div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="calendar-content">
        <template v-if="processes.length > 0">
          <div v-for="(process, key) in processes" :key="key" class="process">
            <div class="number-column column">{{ process.process.number }}</div>
            <div class="process-column column ellipsis pointer" :title="process.process.text" @click="openFullName">
              {{ process.process.text }}
            </div>
            <template v-for="(quarter, key) in makeQuarter(process)" :key="key">
              <div class="quarter-column column" :style="quarterWidth(key + 1)">
                <template v-for="(month, key1) in quarter.months" :key="key1">
                  <div class="quarter-table" :class="{ gray: month.number % 2 === 0 }">
                    <div class="quarter-days">
                      <div
                        v-for="(day, key2) in month.days"
                        :key="key2"
                        class="month-day"
                        :class="[{ active_day: day.active }, { commission_day: day.commission }]"
                        @click="openCreateControl(day, process.process)"
                      >
                        <div v-if="day.message != ''" class="day-message">{{ day.message }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
Date.prototype.daysInMonth = function () {
  return 33 - new Date(this.getFullYear(), this.getMonth(), 33).getDate()
}
import dropdownListWithHeader from '@/components/widgets/simple-components/inputs/dropdown/dropdownListWithHeader'

export default {
  name: 'InspectionPage',
  components: { dropdownListWithHeader },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      months: ['ЯНВ', 'ФЕВ', 'МАР', 'АПР', 'МАЙ', 'ИЮН', 'ИЮЛ', 'АВГ', 'СЕН', 'ОКТ', 'НОЯ', 'ДЕК'],
      medTypes: [],
      processes: []
    }
  },
  beforeMount() {
    this.$api.get('organization/get-organization-medtypes').then((res) => {
      if (res.data.ok == 1) {
        this.medTypes = res.data.data
        this.medTypes.unshift({ text: 'Все', id: '' })
      }
    })
    this.getAllProcesses()
  },
  methods: {
    getDays(month) {
      let now = new Date()
      let days = []
      now.setFullYear(this.currentYear)
      now.setMonth(month - 1)
      for (let i = 1; i <= now.daysInMonth(); i++) {
        now.setDate(i)
        days.push(i)
      }
      return days
    },
    makeQuarter(process) {
      let quarters = []
      let months = []
      for (let i = 1; i <= 12; i++) {
        months.push({
          text: this.months[i - 1],
          number: i,
          days: []
        })
        if (i % 3 === 0) {
          for (let n = 0; n < months.length; n++) {
            months[n].days = this.createDateItems(months[n].number, process)
          }
          quarters.push({ months: months, number: i % 3 })
          months = []
        }
      }
      return quarters
    },
    getDateString(timestamp) {
      let current_date = new Date(timestamp)
      return current_date.getMonth() + 1 + '-' + current_date.getDate() + '-' + current_date.getFullYear()
    },
    createDateItems(month, process) {
      let days = this.getDays(month)
      let result = []
      let controls = process.controls
      if (controls) {
        for (let i = 0; i < days.length; i++) {
          let dayItem = {
            number: days[i],
            active: false,
            commission: false,
            message: '',
            date: new Date(this.currentYear, month - 1, days[i])
          }
          for (let n = 0; n < controls.length; n++) {
            let current_date = new Date(this.currentYear, month - 1, days[i])
            let start_date = new Date(this.getDateString(controls[n].start_date * 1000))
            let stop_date = new Date(this.getDateString(controls[n].finish_date * 1000))
            let commission_date = new Date(this.getDateString(controls[n].commission_date * 1000))
            if (current_date.getTime() >= start_date.getTime() && current_date.getTime() <= stop_date.getTime()) {
              dayItem.active = true
              if (controls[n].assurance) {
                dayItem.message = controls[n].assurance.text
              }
              dayItem.control = controls[n]
            }
            if (current_date.getTime() === commission_date.getTime()) {
              dayItem.commission = true
              dayItem.message = 'Заседание комиссии'
              dayItem.control = controls[n]
            }
          }
          result.push(dayItem)
        }
      }
      return result
    },
    openCreateControl(day, process) {
      if (day.active || day.commission) {
        this.$router.push('/control/edit/' + day.control.id)
        return
      }
      let textDate = day.date.getDate() + '-' + (day.date.getMonth() + 1) + '-' + day.date.getFullYear()
      this.$router.push('/control/create/' + textDate + '&' + process.id)
    },
    getAllProcesses() {
      this.$api.get('control/get-processes').then((res) => {
        if (res.data.ok == 1) {
          this.processes = res.data.data
        }
      })
    },
    changeProcessType(val) {
      if (val.id === '') {
        this.getAllProcesses()
      } else {
        this.$api.get('control/get-processes-by-med-id?id=' + val.id).then((res) => {
          if (res.data.ok === 1) {
            this.processes = res.data.data
          }
        })
      }
    },
    openFullName(evt) {
      let element = evt.target
      if (element.classList.contains('ellipsis')) {
        element.classList.remove('ellipsis')
      } else {
        element.classList.add('ellipsis')
      }
    },
    quarterWidth(quarter) {
      let months = quarter * 3
      let result = 0
      for (let i = (quarter - 1) * 3; i < months; i++) {
        let days = this.getDays(i + 1).length
        result += days * 40
      }
      return result + 6
    }
  }
}
</script>

<style scoped>
.month-day:hover .day-message {
  display: block;
}
.month-day {
  position: relative;
}
.day-message {
  display: none;
  position: absolute;
  width: 250px;
  z-index: 9;
  box-shadow: inset 0px -3px 9px rgb(0 0 0 / 13%);
  border-radius: 6px;
  bottom: 120%;
  padding: 10px;
  background-color: white;
}
.filter {
  padding-right: 40px;
}
.filters {
  display: flex;
  width: 100%;
}
.year-text {
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 400;
  font-size: 16px;
}
.year {
  height: 40px;
  align-items: center;
  display: flex;
}
.next-arrow {
  background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='30' height='30' rx='15' transform='matrix(-1 0 0 1 30 0)' fill='url(%23paint0_linear_1701_11507)'/%3E%3Cg filter='url(%23filter0_d_1701_11507)'%3E%3Cpath d='M13.2089 11.4218C13.0736 11.2553 12.9997 11.0473 12.9997 10.8328C12.9997 10.6182 13.0736 10.4102 13.2089 10.2438C13.2693 10.1677 13.3461 10.1063 13.4335 10.0641C13.5209 10.0219 13.6168 10 13.7139 10C13.811 10 13.9068 10.0219 13.9942 10.0641C14.0817 10.1063 14.1585 10.1677 14.2189 10.2438L17.7909 14.4098C17.9262 14.5762 18 14.7842 18 14.9988C18 15.2133 17.9262 15.4213 17.7909 15.5878L14.2189 19.7548C14.1585 19.8308 14.0817 19.8922 13.9942 19.9344C13.9068 19.9766 13.811 19.9985 13.7139 19.9985C13.6168 19.9985 13.5209 19.9766 13.4335 19.9344C13.3461 19.8922 13.2693 19.8308 13.2089 19.7548C13.0736 19.5883 12.9997 19.3803 12.9997 19.1658C12.9997 18.9512 13.0736 18.7432 13.2089 18.5768L16.2759 14.9988L13.2089 11.4218Z' fill='%23F2F2F2'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_1701_11507' x='12.9998' y='10' width='7.00024' height='11.9985' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeGaussianBlur stdDeviation='0.5'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1701_11507'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1701_11507' result='shape'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_1701_11507' x1='15' y1='0' x2='15' y2='30' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  width: 30px;
  height: 30px;
}
.previous-arrow {
  transform: rotate(180deg);
  background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='30' height='30' rx='15' transform='matrix(-1 0 0 1 30 0)' fill='url(%23paint0_linear_1701_11507)'/%3E%3Cg filter='url(%23filter0_d_1701_11507)'%3E%3Cpath d='M13.2089 11.4218C13.0736 11.2553 12.9997 11.0473 12.9997 10.8328C12.9997 10.6182 13.0736 10.4102 13.2089 10.2438C13.2693 10.1677 13.3461 10.1063 13.4335 10.0641C13.5209 10.0219 13.6168 10 13.7139 10C13.811 10 13.9068 10.0219 13.9942 10.0641C14.0817 10.1063 14.1585 10.1677 14.2189 10.2438L17.7909 14.4098C17.9262 14.5762 18 14.7842 18 14.9988C18 15.2133 17.9262 15.4213 17.7909 15.5878L14.2189 19.7548C14.1585 19.8308 14.0817 19.8922 13.9942 19.9344C13.9068 19.9766 13.811 19.9985 13.7139 19.9985C13.6168 19.9985 13.5209 19.9766 13.4335 19.9344C13.3461 19.8922 13.2693 19.8308 13.2089 19.7548C13.0736 19.5883 12.9997 19.3803 12.9997 19.1658C12.9997 18.9512 13.0736 18.7432 13.2089 18.5768L16.2759 14.9988L13.2089 11.4218Z' fill='%23F2F2F2'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_1701_11507' x='12.9998' y='10' width='7.00024' height='11.9985' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeGaussianBlur stdDeviation='0.5'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1701_11507'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1701_11507' result='shape'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_1701_11507' x1='15' y1='0' x2='15' y2='30' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  width: 30px;
  height: 30px;
}
.content-filter {
  padding-bottom: 20px;
}
.quarter-table.gray {
  background-color: #f2f2f2;
}
.process .process-column {
  padding-bottom: 0;
  padding-top: 0;
  align-items: center;
  display: flex;
  border-right: 1px solid #cccccc;
}

.process .ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  padding-top: 8px;
}

.process .number-column {
  border-right: 1px solid #cccccc;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  align-items: center;
}

.process .quarter-column {
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
}

.quarter-month {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #cccccc;
}

.month-day:first-child {
  border-left: none;
}

.month-day:last-child {
  border-right: none;
}

.month-day {
  width: 40px;
  height: 40px;
  border: 0.5px solid #cccccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quarter-days {
  width: 100%;
  display: flex;
}

.quarter-table {
  border-right: 1px solid #cccccc;
  border-left: 1px solid #cccccc;
}

.quarter-column {
  justify-content: center;
  text-align: center;
  flex: none;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
}

.process {
  display: flex;
  border-left: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
}

.column {
  padding: 20px;
}

.calendar-subheader .quarter-column {
  padding: 0;
}

.calendar-subheader {
  display: flex;
  border-bottom: 1px solid #cccccc;
  width: fit-content;
  border-left: 1px solid #cccccc;
}

.horizontal-calendar::-webkit-scrollbar {
  height: 10px; /* ширина scrollbar */
}

.horizontal-calendar::-webkit-scrollbar-track {
  background: #d5d5d5; /* цвет дорожки */
}

.horizontal-calendar::-webkit-scrollbar-thumb {
  background-color: #a9a9a9; /* цвет плашки */
  border-radius: 20px; /* закругления плашки */
}

.horizontal-calendar {
  overflow-x: auto;
  padding-bottom: 10px;
}

.calendar-subheader .process-column {
  border-right: 1px solid #cccccc;
}

.process-column {
  width: 450px;
  flex: none;
}

.number-column {
  width: 75px;
  flex: none;
}

.calendar-header .column:last-child {
  border-right: none;
}

.calendar-header .column:first-child {
  border-left: none;
}

.calendar-header .column {
  border-right: 1px solid white;
  border-left: 1px solid white;
}

.calendar-header {
  display: flex;
  width: fit-content;
  background: linear-gradient(180deg, #37c489 0%, #00cccc 100%);
  color: white;
}

.page-header {
  padding-bottom: 30px;
}

.content {
  background-color: white;
  padding: 20px 40px;
  filter: drop-shadow(0px 3px 9px rgba(0, 0, 0, 0.125));
}
.month-day.active_day {
  background-color: #37c489;
}
.month-day.commission_day {
  background-color: rgb(214, 89, 89);
}
</style>
